<div class="flex-col" style="align-items: center">
    <div class="filter-ndvi-header">Filter NDVI Index</div>

    <app-date-range-selector style="width: 100%;" (periodSelected)="handlePeriodSelection($event)"></app-date-range-selector>

    <div class="flex-col" *ngIf="isCustomRange">
        <div class="flex-1">
            <mat-label class="fieldLabel">{{ 'DATE-RANGE-DIALOG.FROM-DATE' | translate }}</mat-label>
            <br />
            <mat-form-field appearance="outline">
                <input [max]="capturedToDate" matInput [(ngModel)]="capturedFromDate" [matDatepicker]="pickerFrom" readonly>
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="flex-1">
            <mat-label class="fieldLabel">{{ 'DATE-RANGE-DIALOG.TO-DATE' | translate }}</mat-label>
            <br />
            <mat-form-field appearance="outline">
                <input [min]="capturedFromDate" matInput [(ngModel)]="capturedToDate" [matDatepicker]="pickerTo" readonly>
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
            </mat-form-field>
        </div>
    </div>

    <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between">
        <button mat-flat-button (click)="cancel()" class="date-range-cancel">{{ 'DATE-RANGE-DIALOG.CANCEL' | translate }}</button>
        <button mat-flat-button (click)="applyDates()" class="buttons">{{ 'DATE-RANGE-DIALOG.APPLY' | translate }}</button>
    </div>
</div>